module.exports = __webpack_public_path__ + "img/rule4.4dd4eb2c.jpg";